import { useDispatch, useSelector } from 'react-redux'
import { RaytebRequests } from '../../../_services'
import useFetch from '../../../_services/fetch'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import {
  PrescriptionViewModel,
  TicketServePrescriptionType,
  TicketServeRowPrescriptionType,
} from '../../../models/ViewModels/PrescriptionViewModel'
import {
  LoadingFit,
  PresentationServeCard,
  RaytebModal,
} from '../../../share/Components'
import {
  Button,
  DatePicker,
  Icon,
  ProvideTypeahead,
  RaytebForm,
  Table,
  TextBox,
  Typeahead,
  TypeaheadText,
} from '../../../share/Elements'
import React, { useEffect, useState } from 'react'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import { TicketServeViewModel } from '../../../models/ViewModels/TicketServeSaveViewModel'
import {
  addOrUpdatePrescription,
  trueDeliveredTicketServe,
  updateShouldPush,
  updateTicketServeRow,
} from '../../../storeManager/Reducers/prescriptionSlice'
import { toast } from 'react-toastify'
import {
  PresentationServeCardInterface,
  PresentationTicketServeInterface,
} from '../../../Interfaces/PresentationServeCardInterface'
import { GetPriceViewModel } from '../../../models/ViewModels/GetPriceViewModel'
import { ErrorTypeEnum } from '../../../_services/ResponseErrorType'
import { ReactElement } from 'react'

type TypeaheadData = {
  show: boolean
  data?: any
}

const Serve = ({
  ticketServe,
  ticketId,
  printCode,
  prescriptionId,
  isPreview,
  setButtomPage,
}: {
  ticketServe: TicketServePrescriptionType
  ticketId: string
  prescriptionId: string
  printCode: string
  isPreview?: boolean
  setButtomPage?: (child: ReactElement | null) => void
}) => {
  const [data, setData] = useState<TicketServe_ServeViewModel>({})
  const dispatch = useDispatch()
  const [showList, setshowList] = useState<TypeaheadData>({
    show: false,
    data: {},
  })
  const [showModal, setShowModal] = useState<TypeaheadData>({
    show: false,
    data: {},
  })
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const getServe = useFetch<
    Array<TicketServe_ServeViewModel>,
    unknown,
    {
      filter: string
      isSepas: boolean
    }
  >({
    request: RaytebRequests.TicketServe_Serves_GET({
      token: user.token,
      headers: { centerId: center.id },
    }),
  })

  const [price, setPrice] = useState<GetPriceViewModel>({})

  const presentationTicketServe = useFetch<
    PresentationTicketServeInterface,
    unknown,
    {
      rowId: string
      prescriptionId: string
      count: number
    }
  >({
    request: RaytebRequests.TicketServe_PresentationTicketServes_POST({
      token: user.token,
    }),
    onSuccess(data) {
      setPresentationModal({ show: false })
      setPrice({
        show: true,
        insureShare: data.row.insureShare,
        messages: data.row.messages,
        patientShare: data.row.patientShare,
        total: data.row.total,
      })
      dispatch(trueDeliveredTicketServe(data.row.id))
      data.messages?.forEach((n) => {
        toast[n.flag](n.message)
      })
    },
  })
  const buttomElement = (
    <div className='mt-2 flex justify-center items-center px-6 gap-10 w-full'>
      <Button
        onClick={() => {
          setShowModal({ ...showList, show: false })
          setData({ isEdit: false })
          setButtomPage?.(null)
        }}
        className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg md:!w-56'
      >
        انصراف
      </Button>
      <Button
        onClick={() => document.getElementById('saveServeSubmit')?.click()}
        className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg md:!w-56'
      >
        تایید
      </Button>
    </div>
  )
  const selectedItem = (item: TicketServe_ServeViewModel) => {
    setData({ id: item.id, isEdit: false, title: item.title })
    setShowModal({ ...showList, show: true })
    setshowList({ ...data, show: false })
    setButtomPage?.(buttomElement)
    setTimeout(() => {
      document.getElementById('TotalNumber')?.focus()
    }, 200)
    setshowList({ ...showList, show: false })
    getServe.reFetch(null, {
      filter: '',
      isSepas: isSepas,
    })
  }
  const [isSepas, setIsSepas] = useState<boolean>(false)
  const [rowParam, setRowParam] = useState<TicketServeInputModel>({})

  const [presentationModal, setPresentationModal] = useState<{
    show: boolean
    data?: TicketServeRowPrescriptionType
  }>({ show: false })

  const saveTicketServe = useFetch<TicketServeViewModel, TicketServeInputModel>(
    {
      request: RaytebRequests.TicketServe_AddOrUpdate_POST({
        token: user.token,
      }),
      onSuccess(data) {
        dispatch(updateTicketServeRow(data.rows))
        dispatch(updateShouldPush(true))
        setShowModal({ show: false })
        setButtomPage?.(null)
        setData({ ...data, isEdit: false, title: '' })
        data.messages?.forEach((n) => {
          toast[n.flag](n.message)
        })
      },
    }
  )

  const getPrice = useFetch<
    GetPriceViewModel,
    unknown,
    {
      rowId: string
      prescriptionId: string
    }
  >({
    request: RaytebRequests.TicketServe_GetPrice_GET({ token: user.token }),
    onSuccess(data) {
      setPrice({
        show: true,
        insureShare: data.insureShare,
        messages: data.messages,
        patientShare: data.patientShare,
        total: data.total,
      })
    },
  })
  const getTicketServeByPrintCode = useFetch<
    Array<TicketServeViewModel>,
    unknown,
    {
      printCode: string
      prescriptionId: string
    }
  >({
    request: RaytebRequests.TicketServe_TicketServesByPrintCode_GET({
      token: user.token,
    }),
    onSuccess(data) {
      dispatch(updateTicketServeRow(data))
    },
  })
  const removeTicketServe = useFetch<
    PrescriptionViewModel,
    unknown,
    { ticketId: string; id: string }
  >({
    request: RaytebRequests.TicketServe_Remove_DELETE({ token: user.token }),
    onSuccess(data) {
      dispatch(addOrUpdatePrescription(data))
      dispatch(updateShouldPush(true))
    },
  })
  useEffect(() => {
    if (!isPreview) {
      getServe.reFetch(null, {
        filter: '',
        isSepas: isSepas,
      })
      setRowParam({ ...rowParam, serveType: isSepas ? 1 : 0 })
    }
  }, [isSepas])
  return (
    <>
      <div className='p-2 relative'>
        <LoadingFit
          isLoading={
            saveTicketServe.isLoading ||
            removeTicketServe.isLoading ||
            presentationTicketServe.isLoading ||
            getPrice.isLoading ||
            getTicketServeByPrintCode.isLoading
          }
        />
        {!isPreview ? (
          <>
            <ProvideTypeahead
              className={`mt-5 col-span-2 ${data.isEdit
                ? 'before:absolute before:z-50 before:bg-white/30 before:w-full before:h-full'
                : ''
                }`}
              showList={showList.show}
              listChildren={
                <ListChildren
                  onClick={(item) => {
                    selectedItem(item)
                  }}
                  listData={getServe.result}
                  isLoading={getServe.isLoading}
                  onHide={() => setshowList({ show: false })}
                />
              }
            >
              <div className='px-1 flex justify-start items-end md:!w-1/2 md:mx-auto'>
                <Typeahead
                  innerText='خدمت پزشکی'
                  className='!w-full'
                  onFocus={() => {
                    console.log('Typeahead')
                    setshowList({ ...showList, show: true })
                  }}
                  onChange={(e) =>
                    getServe.reFetch(null, {
                      filter: e.target.value,
                      isSepas: isSepas,
                    })
                  }
                  value={data.title}
                  onClick={(e) => e.target.select()}
                ></Typeahead>

                <Icon
                  icon='rayteb-medical-imaging-alternative-pet'
                  className={`!text-2xl ${isSepas ? '!text-secondaryLight' : '!text-primaryLight'
                    }`}
                  onClick={() => {
                    console.log('isSepas')
                    setIsSepas(!isSepas)
                  }}
                />
              </div>
            </ProvideTypeahead>
          </>
        ) : (
          ''
        )}
        {showModal.show && !isPreview ? (
          <RaytebForm
            checkIsRequired={true}
            onSubmit={(e) => {
              saveTicketServe.reFetch({
                description: e.target['description'].value,
                effectiveDate:
                  e.target['effectiveDate'].getAttribute('rayteb-value'),
                id: rowParam.id,
                repeatCount: e.target['repeatCount'].value,
                repeatType: rowParam.repeatType,
                serveType: rowParam.serveType,
                totalNumber: e.target['totalNumber'].value,
                serveId: data.id,
                prescriptionId: prescriptionId,
              })
            }}
          >
            <div className='w-full p-1 grid grid-cols-2 py-3 gap-x-3 gap-y-6'>
              <TextBox
                id='TotalNumber'
                innerText='تعداد '
                isRequired={true}
                Type={TextBoxTypeEnum.Text}
                value={rowParam.totalNumber?.toString()}
                name='totalNumber'
                className='w-full !border-0 !border-b !rounded-none
             !focus:border-0 !focus:border-b focus:!ring-0'
              />
              <DatePicker
                raytebValue={rowParam.effectiveDate}
                canDeleteDate={true}
                value={
                  rowParam.effectiveDate
                    ? new Date(rowParam.effectiveDate).toShamsi()
                    : ''
                }
                name='effectiveDate'
                innerText='تاریخ موثر'
                className='w-full !border-0 !border-b !rounded-none
             !focus:border-0 !focus:border-b focus:!ring-0'
              />
              <TypeaheadText<{
                value: number
                title: string
              }>
                selected={(e) => {
                  setRowParam({ ...rowParam, repeatType: e.value })
                }}
                listData={[
                  { title: 'روز', value: 0 },
                  { title: 'هفته', value: 1 },
                  { title: 'ماه', value: 2 },
                ]}
                fieldItem='title'
                fieldValue='value'
                isReadOnly={false}
                innerText='نوع تکرار نسخه'
                className='!bg-white'
                classNameList='h-20'
              />
              <TextBox
                innerText='دوره تکرار'
                Type={TextBoxTypeEnum.Number}
                value={rowParam.repeatCount?.toString()}
                name='repeatCount'
                className='w-full border-0 border-b rounded-none
             focus:!border-0 focus:!border-b focus:!ring-0'
              />
              <div className='col-span-2 mt-3'>
                <TextBox
                  innerText='توضیحات دارو خدمت پزشکی'
                  Type={TextBoxTypeEnum.Text}
                  className='!w-full  h-20'
                  name='description'
                  value={rowParam.description}
                />
              </div>
            </div>
            <input type='submit' id='saveServeSubmit' className='hidden' />
          </RaytebForm>
        ) : (
          <>
            <RaytebForm
              className='flex flex-col justify-center items-center mt-6'
              onSubmit={(e) => {
                if (e.target['code']) {
                  getTicketServeByPrintCode.reFetch(null, {
                    printCode: e.target['code'].value!,
                    prescriptionId: prescriptionId,
                  })
                }
              }}
            >
              <TextBox
                innerText='کد رهگیری نسخه'
                Type={TextBoxTypeEnum.Number}
                className={`!text-[11px] `}
                value={printCode}
                name='code'
              />
              <Button
                type='submit'
                className='p-2 bg-secondary mt-2 text-xs text-white'
              >
                جستجو
              </Button>
            </RaytebForm>
            <div className='w-full grid grid-cols-1 mt-6 gap-3 md:grid-cols-3'>
              {ticketServe.rows?.map((n, i) => (
                <PresentationServeCard
                  disableEvent={isPreview}
                  key={i}
                  serveTitle={n.title?.shortText(50)!}
                  effectiveDate={
                    n.effectiveDate ? new Date(n.effectiveDate).toShamsi() : ''
                  }
                  isPresentation={n.isDelivered}
                  canPresentation={!printCode ? true : false}
                  description={n.description?.shortText(30)}
                  isDisable={n.isDeleted}
                  id={n.id}
                  onDelete={() => {
                    removeTicketServe.reFetch(null, {
                      id: n.id!,
                      ticketId: ticketId,
                    })
                  }}
                  onPresentation={() => {
                    if (n.totalNumber! === 1) {
                      presentationTicketServe.reFetch(null, {
                        count: 1,
                        prescriptionId: prescriptionId,
                        rowId: n.id!,
                      })
                    } else {
                      setPresentationModal({ show: true, data: n })
                    }
                  }}
                  onPrice={() => {
                    getPrice.reFetch(null, {
                      rowId: n.id!,
                      prescriptionId: prescriptionId!,
                    })
                  }}
                  onEdit={() => {
                    setRowParam({
                      description: n.description,
                      totalNumber: n.totalNumber,
                      id: n.id,
                      effectiveDate: n.effectiveDate,
                      serveId: n.serveId,
                      serveType: n.serveType,
                    })
                    setShowModal({ show: true })
                    setData({ isEdit: true, id: n.serveId, title: n.title })
                    setButtomPage?.(buttomElement)
                  }}
                />
              ))}
            </div>
          </>
        )}
      </div>

      <RaytebModal
        isOpen={price.show ?? false}
        hideModal={() => setPrice({ show: false })}
        title='قیمت'
      >
        <div className='p-2'>
          <Table>
            <thead className='text-xs text-primary h-8 border-b border-disable'>
              <tr>
                <th
                  scope='col'
                  className='pt-1 p-0 text-center font-normal w-10'
                >
                  سهم سازمان
                </th>
                <th scope='col' className='pt-1 p-0 text-center font-normal'>
                  سهم بیمار
                </th>
                <th
                  scope='col'
                  className='pt-1 pl-2 text-center font-normal w-10'
                >
                  کل
                </th>
              </tr>
            </thead>
            <tbody className='text-xs'>
              <tr className={`[&>*]:h-14`}>
                <td className='text-center'>{price.insureShare}</td>
                <td className='text-center'>{price.patientShare}</td>

                <td className='text-center'>{price.total}</td>
              </tr>
            </tbody>
          </Table>
          <div className='text-xs w-full flex flex-col gap-3'>
            {price.messages?.map((n) => (
              <span
                className={`${n.flag === ErrorTypeEnum.Error
                  ? 'text-danger'
                  : n.flag === ErrorTypeEnum.Info
                    ? 'text-primaryLight'
                    : n.flag === ErrorTypeEnum.Warning
                      ? 'text-warn'
                      : ''
                  }`}
              >
                {n.message}
              </span>
            ))}
          </div>
        </div>
      </RaytebModal>
      <RaytebModal
        isOpen={presentationModal.show}
        title='ارائه خدمت پزشکی'
        hideModal={() => {
          setPresentationModal({ show: false })
        }}
      >
        <RaytebForm
          className='p-3 grid grid-cols-4 gap-3 '
          checkIsRequired={true}
          onSubmit={(e) => {
            presentationTicketServe.reFetch(null, {
              count: e.currentTarget['count'].value,
              prescriptionId: prescriptionId,
              rowId: presentationModal.data?.id!,
            })
          }}
        >
          <div className='text-xs  col-span-4'>
            <span className='font-bold text-primary'>
              {presentationModal.data?.title}
            </span>
            <label className='pr-4'>تعداد کل : </label>
            <span className='font-bold text-primaryDark'>
              {presentationModal.data?.totalNumber}
            </span>
          </div>
          <div className='text-xs flex gap-2 col-span-4 mt-4 mx-auto'>
            <span className='font-bold text-primary'>
              <TextBox
                innerText='تعداد ارائه'
                Type={TextBoxTypeEnum.Number}
                name='count'
                isRequired={true}
              />
            </span>
          </div>
          <div className='text-xs flex gap-2 col-span-4 py-5'>
            <Button
              onClick={() => {
                setPresentationModal({ show: false })
              }}
              className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              انصراف
            </Button>
            <Button
              type='submit'
              className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              تایید
            </Button>
          </div>
        </RaytebForm>
      </RaytebModal>
    </>
  )
}

type ListChildrenType = {
  listData?: Array<TicketServe_ServeViewModel>
  className?: string | undefined
  isLoading: boolean
  onHide?: () => void
  onClick?: (param: TicketServe_ServeViewModel) => void
}
const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className='border-b border-disable bg-white py-2 px-1 flex items-center'>
          <Icon
            icon='rayteb-android-close'
            className='text-xl'
            onClick={() => onHide?.()}
          />

          <p className='text-xs mr-2 font-bold text-warn '>
            برای تجویز بر روی یکی از موارد کلیک کنید
          </p>
        </div>

        <div className='h-64 overflow-y-auto'>
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm ${className ?? ''}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className='flex justify-start items-center   py-1  w-full hover:bg-primaryDefault hover:cursor-pointer '
                onClick={() => onClick?.(n)}
              >
                <p className='text-xs font-bold text-end text-primaryLight'>
                  {n.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}
export default React.memo(Serve)
